/* istanbul ignore file */

/**
 *
 * Asynchronously loads the component for JobLogsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

const JobLogsPage = lazyLoad(
  () => import('./index'),
  module => module.JobLogsPage,
);

export default JobLogsPage;
